import { Link } from 'react-router-dom'
import Wordmark from './Wordmark'
import MetaPhaseSymbol from '../brand/MetaPhaseSymbol'
import { COPYRIGHT_YEAR, OPERATOR, PRODUCT_TAGLINE } from '../../content/provenance'

/**
 * Site footer, a dark band in both themes.
 *
 * Brand block on the left: the mark, the product name, what it is, and the
 * copyright line. Link groups in the middle, grouped by what someone is trying
 * to do rather than by what the pages are. The MetaPhase credit sits on the
 * right, where it reads as the maker's mark rather than as part of the product.
 *
 * The credit appears on every public page and is stated as fact. There is no
 * disclaimer here; the pre-header answers who operates the service.
 */

const GROUPS = [
  {
    id: 'explore',
    heading: 'Explore',
    links: [
      { to: '/', label: 'Home' },
      { to: '/about', label: 'About' },
    ],
  },
  {
    id: 'info',
    heading: 'Info',
    links: [
      { to: '/privacy', label: 'Privacy' },
      { to: '/accessibility', label: 'Accessibility' },
      { to: '/security', label: 'Security' },
    ],
  },
]

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-footer text-footer-ink">
      <div className="page-shell py-10">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_2fr_1fr]">
          {/* Brand */}
          <div>
            <Wordmark fixed="dark" className="h-9 w-auto max-w-full" />
            <p className="mt-3 text-sm font-semibold text-footer-accent italic">
              {PRODUCT_TAGLINE}
            </p>
            <p className="mt-4 text-xs text-footer-ink/70">
              &copy; {COPYRIGHT_YEAR} All rights reserved.
            </p>
          </div>

          {/* Links */}
          <div className="flex gap-12">
            {GROUPS.map((group) => (
              <nav key={group.id} aria-labelledby={`footer-${group.id}`}>
                <h2
                  id={`footer-${group.id}`}
                  className="text-xs font-bold tracking-wide uppercase"
                >
                  {group.heading}
                </h2>
                <ul className="mt-3 space-y-2">
                  {group.links.map((link) => (
                    <li key={link.to}>
                      <Link
                        to={link.to}
                        className="text-sm text-footer-ink underline-offset-2 hover:underline"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </nav>
            ))}
          </div>

          {/* Maker's mark */}
          <div className="lg:text-right">
            <MetaPhaseSymbol className="size-14 text-footer-accent lg:ml-auto" />
            <p className="mt-3 text-sm font-semibold italic">Mission Protoware&trade;</p>
            <p className="mt-1 text-sm">
              Built by{' '}
              <a
                href={OPERATOR.url}
                rel="noreferrer"
                className="font-bold text-footer-accent underline underline-offset-2"
              >
                {OPERATOR.name}
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
